// Stores
import { useUiStore } from '@stores/ui';

// Personal libs
import { tailleFichier } from '@shared/lib/tools.lib';
import {
  checkEmail,
  checkPassword,
  checkUsername,
} from '@shared/lib/security.lib';

export const usernameExample = 'Michel D.';
export const emailExample = 'prenom.nom@domaine.fr';
export const passwordExample = 'Azerty!1234';

/**
 * **************************************************
 * MESSAGES
 * **************************************************
 */
export const usernameErrorMessage = () => {
  const uiStore = useUiStore();
  return `Merci de saisir un nom d'utilisateur de ${
    uiStore?.config?.security?.username?.min ?? 3
  } à ${
    uiStore?.config?.security?.username?.max ?? 64
  } caractères maximum (ex: ${usernameExample})`;
};

export const emailErrorMessage = () =>
  `Merci de saisir une adresse email valide (ex: ${emailExample})`;

export const passwordErrorMessage = () =>
  `Merci de saisir un mot de passe valide (ex: ${passwordExample})`;

export const messageErrorMessage = () =>
  "Merci de saisir un message d'au moins 6 caractères (exemple: bonjour)";

export const subjectErrorMessage = () =>
  "Merci de sélectionner l'objet de votre message (exemple: Autre sujet)";

export const requiredErrorMessage = () =>
  'Merci de saisir au moins un caractère (chaine vide interdite)';

export const requiredSelectAtLeastOneDemonstratorMessage = () =>
  'Merci de saisir au moins un élément dans la liste des pratiquants';

export const videoFileErrorMessage = () => {
  const uiStore = useUiStore();
  return `Choisir une vidéo au format MP4 et de moins de ${tailleFichier(
    uiStore.config?.uploader?.maxFileSize ?? 0,
  )}`;
};

/**
 * **************************************************
 * CHECKERS
 * **************************************************
 */

export const usernameRules = [
  (val) => (val && checkUsername(val)) || usernameErrorMessage(),
];

export const emailRules = [
  (val) => (val && checkEmail(val)) || emailErrorMessage(),
];

export const passwordRules = [
  (val) => {
    const uiStore = useUiStore();

    return (
      (val && checkPassword(val, uiStore.config?.security)) ||
      passwordErrorMessage()
    );
  },
];

export const messageRules = [
  (val) => (val && val.length >= 6) || messageErrorMessage(),
];

export const subjectRules = [
  (val) => (val !== null && val != '') || subjectErrorMessage(),
];

export const videoFileRules = [
  (val) => (val != null && !Array.isArray(val)) || videoFileErrorMessage(),
];

export const requiredRules = [
  (val) => (val && val.length > 0) || requiredErrorMessage(),
];

export const requiredAtLeastOneDemonstrator = [
  (val) => (val != null) || requiredSelectAtLeastOneDemonstratorMessage(),
];
